import React, { useEffect } from 'react';
import { Modal as MUIModal } from '@mui/material';
import {
    Box, Grid, GridProps, Text,
} from '@chakra-ui/react';

type ModalProps = {
    title: string
    open: boolean
    onChange: (v: boolean) => void
    children: React.ReactNode | React.ReactNode[]
    innerProps?: GridProps
}

export const Modal: React.FC<ModalProps> = ({
    title,
    open,
    onChange,
    children,
    innerProps,
}) => {
    const handleClose = () => onChange(false);

    useEffect(() => {
        if (open) document.documentElement.style.overflow = 'hidden';
        else document.documentElement.style.overflow = 'scroll';

        return () => {
            document.documentElement.style.overflow = 'scroll';
        };
    }, [open]);

    return (
        <MUIModal
            open={open}
            onClose={handleClose}
        >
            <Grid
                width="100vw"
                height="100vh"
                margin="auto"
                cursor="pointer"
                overscrollBehavior="contain"
            >
                <Grid
                    overscrollBehavior="contain"
                    zIndex={50}
                    margin="auto"
                    width={{
                        base: '80vw',
                        lg: '40vw',
                    }}
                    maxHeight="80vh"
                    height="fit-content"
                    overflow="scroll"
                    background="white"
                    padding="2rem"
                    gap="1rem"
                    cursor="default"
                    {...innerProps}
                >
                    <Text
                        fontSize="2rem"
                        fontWeight="bold"
                    >
                        {title}
                    </Text>
                    <Grid>
                        {children}
                    </Grid>
                </Grid>
                <Box
                    position="absolute"
                    height="100%"
                    width="100%"
                    overscrollBehavior="contain"
                    zIndex={49}
                    onClick={handleClose}
                />
            </Grid>
        </MUIModal>
    );
};
